export default __webpack_public_path__ + "static/media/card_back.6a6339bb.png";